/* ByKashan - product card bar: fast add to cart + "Adding / Added ✓"
   Load ONCE (theme.liquid, before </body>, with defer) – not inside the product card snippet. */
(function () {
	if (window.__bkProductCardInit) return;
	window.__bkProductCardInit = true;
	window.bkCardVersion = '2026-10-28 bundles-no-fetch'; /* type bkCardVersion in the browser console to check which file is live */

	var ADDED_SHOW_MS = 2500;   /* how long "Added ✓" stays */
	var ERROR_SHOW_MS = 3000;   /* how long an error stays on the bar */
	var LOADING_MAX_MS = 10000; /* safety: stop the spinner if nothing comes back */
	var QUICK_VIEW_MS = 30000;  /* products with options are added from the quick view */

	/* Optional: after a fast add, ask the theme to re-start its cart drawer code.
	   Off by default. Turn on only if the drawer's + / - buttons stop working after a fast add. */
	var RELOAD_DRAWER_JS = false;

	/* Blocks in the drawer that are kept as they are when the cart refreshes
	   ("You might also like" etc.), so their pictures and slider keep working. */
	var KEEP_IN_DRAWER = '[class*="recommend"], [class*="upsell"], [class*="up-sell"], [class*="cross-sell"], [class*="also-like"], [class*="complementary"], [data-recommendations], product-recommendations';

	var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

	/* ---------- bar states ---------- */
	function setLoading(bar) {
		bar.classList.remove('is-added', 'is-error');
		bar.classList.add('is-loading');
		clearTimeout(bar.__bkTimer);
		bar.__bkTimer = setTimeout(function () { bar.classList.remove('is-loading'); }, LOADING_MAX_MS);
	}
	function setAdded(bar) {
		clearTimeout(bar.__bkTimer);
		bar.classList.remove('is-loading', 'is-error');
		bar.classList.add('is-added');
		bar.__bkTimer = setTimeout(function () { bar.classList.remove('is-added'); }, ADDED_SHOW_MS);
	}
	function setError(bar, message) {
		clearTimeout(bar.__bkTimer);
		bar.classList.remove('is-loading', 'is-added');
		var el = bar.querySelector('.product-card__bk-label--error');
		if (el && message) el.textContent = message;
		bar.classList.add('is-error');
		bar.__bkTimer = setTimeout(function () { bar.classList.remove('is-error'); }, ERROR_SHOW_MS);
	}
	function clearState(bar) {
		if (!bar) return;
		clearTimeout(bar.__bkTimer);
		bar.classList.remove('is-loading');
	}

	/* ---------- bundles: open the product page instead of showing an error ---------- */
	var BUNDLE_KEY = 'bk-bundle-';

	function isBundleError(msg) { return /bundle|حزمة|باقة/i.test(String(msg || '')); }

	function productUrl(bar) {
		if (bar.tagName === 'A' && bar.href) return bar.href;
		var card = bar.closest('.js-product-card') || bar.closest('.product-card');
		var link = card && card.querySelector('a[href*="/products/"]');
		return link ? link.href : '';
	}
	function rememberBundle(bar, url) {
		try { sessionStorage.setItem(BUNDLE_KEY + bar.getAttribute('data-variant'), url); } catch (e) {}
	}
	function storedBundle(bar) {
		try { return sessionStorage.getItem(BUNDLE_KEY + bar.getAttribute('data-variant')) || ''; } catch (e) { return ''; }
	}
	function knownBundle(bar) {
		if (bar.hasAttribute('data-bk-bundle')) return productUrl(bar);
		return storedBundle(bar);
	}
	function goToProduct(bar) {
		var url = productUrl(bar);
		if (!url) return false;
		rememberBundle(bar, url);
		clearState(bar);
		window.location.href = url;
		return true;
	}

	/* "View product" on bundle cards from the start.
	   A card is a bundle when the card snippet marks its bar with data-bk-bundle (product tag starting with "bundl"),
	   when it is in window.bkBundles, or when Shopify answered "bundle" earlier this visit.
	   No product data is downloaded for this (it used to fetch /products/<handle>.js for every card). */
	var VIEW_LABEL = /^ar/i.test(document.documentElement.lang || '') ? 'عرض المنتج' : 'View product';

	function handleOf(bar) {
		var m = productUrl(bar).match(/\/products\/([^\/?#]+)/);
		return m ? decodeURIComponent(m[1]) : '';
	}

	function applyBundle(bar) {
		if (bar.__bkBundle) return;
		bar.__bkBundle = true;
		bar.setAttribute('data-bk-bundle', '');
		bar.removeAttribute('data-bk-fast');
		var label = bar.querySelector('.product-card__bk-label--add');
		if (label) label.textContent = VIEW_LABEL;
		if (bar.getAttribute('aria-label')) bar.setAttribute('aria-label', VIEW_LABEL);
	}

	function markBundles() {
		var list = (window.bkBundles || []).map(function (h) { return String(h).toLowerCase(); });
		document.querySelectorAll('.js-bk-add-bar').forEach(function (bar) {
			if (bar.__bkBundle || bar.__bkChecked) return;
			bar.__bkChecked = true;
			var handle = handleOf(bar);
			if (bar.hasAttribute('data-bk-bundle') || storedBundle(bar) || (handle && list.indexOf(handle.toLowerCase()) !== -1)) applyBundle(bar);
		});
	}
	function watchBundles() {
		markBundles();
		var t;
		new MutationObserver(function () { clearTimeout(t); t = setTimeout(markBundles, 120); })
			.observe(document.body, { childList: true, subtree: true });
	}
	if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchBundles);
	else watchBundles();

	/* ---------- cart drawer + count ---------- */
	function drawerEl() { return document.getElementById('CartDrawer'); }

	/* only the outermost matches (not blocks inside other matched blocks) */
	function topOnly(list) {
		var arr = Array.prototype.slice.call(list);
		return arr.filter(function (el) { return !arr.some(function (o) { return o !== el && o.contains(el); }); });
	}

	function fire(el, name, detail) {
		el.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: detail }));
	}

	/* scripts put in with innerHTML do not run: re-create them so they do */
	function runScripts(scope) {
		scope.querySelectorAll('script').forEach(function (old) {
			if (old.closest('[data-bk-kept]')) return; /* kept blocks are already running */
			var type = (old.getAttribute('type') || '').toLowerCase();
			if (type && type.indexOf('javascript') === -1 && type !== 'module') return; /* JSON data etc. */
			var s = document.createElement('script');
			Array.prototype.forEach.call(old.attributes, function (a) { s.setAttribute(a.name, a.value); });
			s.textContent = old.textContent;
			old.parentNode.replaceChild(s, old);
		});
	}

	/* ---------- drawer pictures ----------
	   The theme loads cart pictures with its lazy loader. Pictures put in by a fast add
	   never get that call, so they are loaded here, whatever way the theme writes them:
	   data-src / data-srcset (with Shopify's {width} placeholder), data-bgset / data-bg,
	   or a <noscript> copy. Blocks that were kept as they are ("You might also like") are skipped. */
	var keptNow = [];
	function inKept(el) { return keptNow.some(function (k) { return k.contains(el); }); }

	/* make sure the pictures we load are not left invisible by a "still loading" style */
	(function () {
		var css = '#CartDrawer [data-bk-woken]{opacity:1!important;visibility:visible!important;filter:none!important}';
		var s = document.createElement('style');
		s.textContent = css;
		(document.head || document.documentElement).appendChild(s);
	})();

	function pickWidth(el) {
		if (el.__bkW) return el.__bkW; /* same size every time, so a picture is not loaded twice */
		el.__bkW = choose(el);
		return el.__bkW;
	}
	function choose(el) {
		var need = Math.max(200, ((el.parentElement && el.parentElement.offsetWidth) || 200) * (window.devicePixelRatio || 1));
		try {
			var list = JSON.parse(el.getAttribute('data-widths') || '[]');
			if (list.length) {
				for (var i = 0; i < list.length; i++) if (list[i] >= need) return list[i];
				return list[list.length - 1];
			}
		} catch (e) {}
		return Math.min(Math.ceil(need / 100) * 100, 800);
	}
	function fillWidth(url, el) { return String(url).replace(/\{width\}/g, pickWidth(el)); }
	function isSecondImage(el) { return /second|hover|alt-image|secondary/i.test(String(el.className || '')); }
	function markShown(el) {
		el.classList.remove('lazyload', 'lazyloading');
		el.classList.add('lazyloaded', 'is-loaded', 'loaded');
		if (!isSecondImage(el)) el.setAttribute('data-bk-woken', '');
	}
	function firstUrl(set) {
		var part = String(set || '').split(',')[0].trim().split(/\s+/)[0];
		return part || '';
	}

	function wakeImages(scope) {
		var ls = window.lazySizes && window.lazySizes.loader;

		scope.querySelectorAll('img, source, [data-bgset], [data-bg], [data-background-image]').forEach(function (el) {
			if (inKept(el)) return;

			/* already showing the real picture: nothing to do.
			   (A tiny blurred preview does not count: if the theme left a data-src/srcset
			   or the lazyload class, the full picture still has to be loaded.) */
			var pending = el.hasAttribute('data-src') || el.hasAttribute('data-srcset') || el.classList.contains('lazyload') || el.classList.contains('lazyloading');
			if (pending && el.tagName === 'IMG') {
				var want = el.getAttribute('data-src');
				if (want && el.getAttribute('src') === fillWidth(want, el)) pending = false;
				var wantSet = el.getAttribute('data-srcset');
				if (wantSet && el.getAttribute('srcset') === fillWidth(wantSet, el)) pending = false;
			}
			if (!pending && el.tagName === 'IMG' && el.complete && el.naturalWidth > 1 && !/\{width\}/.test(el.currentSrc || el.src || '')) {
				markShown(el);
				return;
			}

			/* the theme's own loader first, when it has one */
			if (ls && el.classList.contains('lazyload')) {
				try { ls.unveil(el); } catch (e) {}
			}

			var ds = el.getAttribute('data-srcset');
			var d = el.getAttribute('data-src');
			var curSrcset = el.getAttribute('srcset') || '';
			if (ds && curSrcset !== fillWidth(ds, el)) el.setAttribute('srcset', fillWidth(ds, el));
			else if (/\{width\}/.test(curSrcset)) el.setAttribute('srcset', fillWidth(curSrcset, el));

			if (el.tagName === 'IMG') {
				var cur = el.getAttribute('src') || '';
				if (d && cur !== fillWidth(d, el)) el.setAttribute('src', fillWidth(d, el)); /* replaces a blurred preview too */
				else if (/\{width\}/.test(cur)) el.setAttribute('src', fillWidth(cur, el));
				if (el.getAttribute('sizes') === 'auto') el.setAttribute('sizes', Math.max(100, el.offsetWidth || 200) + 'px');
				el.setAttribute('loading', 'eager');

				/* nothing to load from: use the <noscript> copy the theme prints next to it */
				if (!el.getAttribute('src') && !el.getAttribute('srcset')) {
					var ns = el.parentElement && el.parentElement.querySelector('noscript');
					var m = ns && /src=["']([^"']+)["']/i.exec(ns.textContent || ns.innerHTML || '');
					if (m) el.setAttribute('src', fillWidth(m[1], el));
				}

				if (el.complete && el.naturalWidth > 1) markShown(el);
				else el.addEventListener('load', function () { markShown(el); }, { once: true });
				markShown(el);
				return;
			}

			if (el.tagName === 'SOURCE') return;

			/* background pictures */
			var bg = el.getAttribute('data-bgset') || el.getAttribute('data-bg') || el.getAttribute('data-background-image');
			if (bg && !el.style.backgroundImage) {
				var url = fillWidth(firstUrl(bg), el);
				if (url) el.style.backgroundImage = 'url("' + url + '")';
			}
			markShown(el);
		});

		if (ls) { try { ls.checkElems(); } catch (e) {} }
	}

	function refreshDrawer(sections) {
		var drawer = drawerEl();
		if (!drawer || !sections) return;
		var id = drawer.getAttribute('data-section-id');
		var html = id && sections[id];
		if (!html) return;

		var fresh = new DOMParser().parseFromString(html, 'text/html').getElementById('CartDrawer');
		if (!fresh) return;

		var wrap = drawer.closest('.shopify-section') || drawer;
		var detail = { sectionId: id };

		/* let the theme let go of the old drawer content */
		if (RELOAD_DRAWER_JS) fire(wrap, 'shopify:section:unload', detail);

		/* keep the live "You might also like" blocks (pictures loaded, slider running) */
		var kept = topOnly(drawer.querySelectorAll(KEEP_IN_DRAWER)).map(function (el) {
			return { el: el, cls: el.className && el.className.baseVal === undefined ? String(el.className) : '', tag: el.tagName };
		});
		kept.forEach(function (k) { if (k.el.parentNode) k.el.parentNode.removeChild(k.el); });

		var changed = [];
		['.js-cart-content', '.cart-drawer__footer'].forEach(function (sel) {
			var oldEl = drawer.querySelector(sel);
			var newEl = fresh.querySelector(sel);
			if (oldEl && newEl) { oldEl.innerHTML = newEl.innerHTML; changed.push(oldEl); }
		});
		if (changed.length < 2) {
			/* first item in an empty cart: footer did not exist yet, so swap the whole body */
			var oldBody = drawer.querySelector('.js-cart-container');
			var newBody = fresh.querySelector('.js-cart-container');
			if (oldBody && newBody) { oldBody.innerHTML = newBody.innerHTML; changed = [oldBody]; }
		}

		/* put the kept blocks back in place of the fresh (empty) copies */
		kept.forEach(function (k) {
			var spot = null;
			topOnly(drawer.querySelectorAll(KEEP_IN_DRAWER)).some(function (el) {
				if (el.tagName === k.tag && String(el.className) === k.cls && !el.__bkKept) { spot = el; return true; }
			});
			if (spot) { spot.parentNode.replaceChild(k.el, spot); k.el.__bkKept = true; k.el.setAttribute('data-bk-kept', ''); }
		});
		kept.forEach(function (k) { k.el.__bkKept = false; });
		keptNow = kept.filter(function (k) { return drawer.contains(k.el); }).map(function (k) { return k.el; });
		drawer.classList.toggle('is-empty', fresh.classList.contains('is-empty'));

		changed.forEach(function (el) { runScripts(el); wakeImages(el); });
		kept.forEach(function (k) { k.el.removeAttribute('data-bk-kept'); });

		/* the theme starts its drawer code again: quantity +/-, remove, recommendations slider */
		if (RELOAD_DRAWER_JS) fire(wrap, 'shopify:section:load', detail);

		/* pictures the theme draws a moment later, and a last check once the drawer is visible */
		[150, 500, 1200].forEach(function (ms) { setTimeout(function () { wakeImages(drawer); }, ms); });
	}

	/* cart badge in the header: the theme's own counter, wherever it is */
	function setBadges(count) {
		var drawer = drawerEl();
		var found = [];
		function add(el) { if (el && found.indexOf(el) === -1 && !(drawer && drawer.contains(el))) found.push(el); }

		document.querySelectorAll('[data-cart-count], [data-cart-item-count], .js-cart-count, .js-header-cart-count, [class*="cart-count"], [class*="cart__count"], [class*="cart-bubble"], [class*="CartCount"]')
			.forEach(add);
		/* plus any number shown inside the cart icon / cart link */
		document.querySelectorAll('[data-js-toggle="CartDrawer"], [data-target="CartDrawer"], a[href$="/cart"], a[href*="/cart?"]').forEach(function (t) {
			if (drawer && drawer.contains(t)) return;
			t.querySelectorAll('*').forEach(function (el) {
				if (!el.children.length && /^\s*\d+\s*$/.test(el.textContent || '')) add(el);
			});
		});

		found.forEach(function (el) {
			['data-cart-count', 'data-cart-item-count', 'data-count'].forEach(function (a) {
				if (el.hasAttribute(a)) el.setAttribute(a, count);
			});
			if (!el.children.length) el.textContent = count;
			else {
				/* bubble with a number inside a child */
				el.querySelectorAll('*').forEach(function (c) {
					if (!c.children.length && /^\s*\d+\s*$/.test(c.textContent || '')) c.textContent = count;
				});
			}
			if (count > 0) {
				el.classList.remove('hide', 'hidden', 'is-hidden', 'is-empty');
				el.removeAttribute('hidden');
			}
		});
	}

	function updateCount() {
		window.fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
			.then(function (r) { return r.json(); })
			.then(function (cart) {
				setBadges(cart.item_count);
				document.dispatchEvent(new CustomEvent('bykashan:cart:updated', { detail: { cart: cart } }));
			})
			.catch(function () {});
	}

	function openDrawer() {
		var drawer = drawerEl();
		if (!drawer) return;
		var toggles = document.querySelectorAll('[data-js-toggle="CartDrawer"], [data-target="CartDrawer"]');
		for (var i = 0; i < toggles.length; i++) {
			var t = toggles[i];
			if (drawer.contains(t)) continue;                       /* skip the close button inside the drawer */
			if (t.getAttribute('aria-expanded') === 'true') return; /* already open */
			t.click();
			return;
		}
	}

	/* ---------- 1. FAST ADD ---------- */
	function fastAdd(bar) {
		var card = bar.closest('.js-product-card');
		var minInput = card && card.querySelector('.js-product-card-min-value');
		var qty = parseInt(minInput && minInput.value, 10) || 1;
		var drawer = drawerEl();
		var sectionId = drawer && drawer.getAttribute('data-section-id');

		var body = { items: [{ id: Number(bar.getAttribute('data-variant')), quantity: qty }] };
		if (sectionId) {
			body.sections = sectionId;
			body.sections_url = window.location.pathname;
		}

		setLoading(bar);
		window.__bkFastAdding = true;

		window.fetch(root + 'cart/add.js', {
			method: 'POST',
			headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
			body: JSON.stringify(body)
		})
			.then(function (res) {
				return res.json().then(function (data) { return { ok: res.ok, data: data }; });
			})
			.then(function (r) {
				window.__bkFastAdding = false;
				if (!r.ok) {
					var msg = r.data && (r.data.description || r.data.message);
					if (isBundleError(msg) && goToProduct(bar)) return; /* bundle: open its page */
					setError(bar, msg);
					return;
				}
				setAdded(bar);
				refreshDrawer(r.data && r.data.sections);
				updateCount();
				if (bar.hasAttribute('data-bk-open-drawer')) openDrawer();
			})
			.catch(function () {
				window.__bkFastAdding = false;
				setError(bar);
			});
	}

	/* ---------- 2. THEME ADD watcher ---------- */
	var lastBar = null;
	var lastClick = 0;

	function themeAdded() {
		if (window.__bkFastAdding || !lastBar || Date.now() - lastClick > QUICK_VIEW_MS) return;
		var bar = lastBar;
		lastBar = null;
		setAdded(bar);
	}
	function themeFailed(message, bar) {
		if (window.__bkFastAdding) return;
		bar = bar || lastBar;
		lastBar = null;
		if (bar && isBundleError(message) && goToProduct(bar)) return; /* bundle: open its page */
		clearState(bar);
	}
	function isAddUrl(url) { return String(url || '').indexOf('/cart/add') !== -1; }
	function errorText(data) { return data ? (data.description || data.message || '') : ''; }

	if (window.fetch) {
		var originalFetch = window.fetch;
		window.fetch = function (input) {
			var url = input && typeof input === 'object' ? input.url : input;
			var request = originalFetch.apply(this, arguments);
			if (isAddUrl(url) && lastBar) {
				var bar = lastBar;
				request.then(function (res) {
					if (res && res.ok) { themeAdded(); return; }
					var copy;
					try { copy = res.clone(); } catch (e) { themeFailed('', bar); return; }
					copy.json().then(function (d) { themeFailed(errorText(d), bar); }, function () { themeFailed('', bar); });
				}, function () { themeFailed('', bar); });
			}
			return request;
		};
	}
	var originalOpen = XMLHttpRequest.prototype.open;
	XMLHttpRequest.prototype.open = function (method, url) {
		if (isAddUrl(url)) {
			this.addEventListener('loadend', function () {
				if (!lastBar) return;
				if (this.status >= 200 && this.status < 300) { themeAdded(); return; }
				var msg = '';
				try { msg = errorText(JSON.parse(this.responseText)); } catch (e) { msg = this.responseText || ''; }
				themeFailed(msg);
			});
		}
		return originalOpen.apply(this, arguments);
	};

	/* ---------- clicks ---------- */
	/* window + capture = runs before the theme's own click handlers */
	window.addEventListener('click', function (e) {
		var bar = e.target && e.target.closest ? e.target.closest('.js-bk-add-bar') : null;
		if (!bar) return;
		if (bar.classList.contains('is-loading')) {
			e.preventDefault();
			e.stopImmediatePropagation();
			return;
		}

		/* bundles go straight to their product page (tagged in the card, or found earlier this visit) */
		var bundleUrl = knownBundle(bar);
		if (bundleUrl) {
			e.preventDefault();
			e.stopImmediatePropagation();
			window.location.href = bundleUrl;
			return;
		}

		if (bar.hasAttribute('data-bk-fast') && bar.hasAttribute('data-variant')) {
			e.preventDefault();
			e.stopImmediatePropagation(); /* the theme does not run: no double add */
			lastBar = null;
			fastAdd(bar);
			return;
		}

		/* theme add (products with options open the quick view) */
		lastBar = bar;
		lastClick = Date.now();
		if (bar.hasAttribute('data-variant')) setLoading(bar);
	}, true);
})();
